// MapEmbed.tsx
import React from 'react';

type Props = {
	readonly address?: string | null;
	readonly className?: string;
	readonly aspectRatio?: string;
	readonly zoom?: number;
};

export function MapEmbed({ address, className, aspectRatio = '16/9', zoom = 16 }: Props) {
	const hasAddress = Boolean(address?.trim());

	if (!hasAddress) {
		return (
			<div
				className={className}
				style={{
					width: '100%',
					aspectRatio,
					borderRadius: 8,
					overflow: 'hidden',
					background: '#eef2f7',
					border: '1px solid #e3e8ef',
					display: 'flex',
					justifyContent: 'center',
					alignItems: 'center',
				}}
			>
				No hay dirección disponible
			</div>
		);
	}

	const src = `https://www.google.com/maps?q=${encodeURIComponent(address!)}&output=embed&z=${zoom}`;

	return (
		<div className={className} style={{ width: '100%', aspectRatio, borderRadius: 8, overflow: 'hidden' }}>
			<iframe
				title={`Mapa ${address}`}
				src={src}
				width="100%"
				height="100%"
				style={{ border: 0, display: 'block' }}
				loading="lazy"
				referrerPolicy="no-referrer-when-downgrade"
				sandbox="allow-scripts"
			/>
		</div>
	);
}
